/**
 * @generated SignedSource<<3381de2547ab1a4eb79dda6279dcabea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionListItemComponent_taskExecution$data = {
  readonly id: string;
  readonly isCompleted: boolean;
  readonly task: {
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionHeaderComponent_Task">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionComponent_TaskExecution" | "TaskExecutionListItemUpdatedInfo_taskExecution">;
  readonly " $fragmentType": "TaskExecutionListItemComponent_taskExecution";
};
export type TaskExecutionListItemComponent_taskExecution$key = {
  readonly " $data"?: TaskExecutionListItemComponent_taskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionListItemComponent_taskExecution">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionListItemComponent_taskExecution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskExecutionHeaderComponent_Task"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionListItemUpdatedInfo_taskExecution"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionComponent_TaskExecution"
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};
})();

(node as any).hash = "f8cd585bfab2b9a3e177b9b7acea1953";

export default node;
